import { push }                          from "connected-react-router";
import React, { FC }                     from "react";
import { useDispatch }                   from "react-redux";
import { Header, Radio, Segment, Table } from "semantic-ui-react";
import PlanId                            from "../../../domain/plan/PlanId";
import Plans                             from "../../../domain/plan/Plans";
import PlanStatusType                    from "../../../domain/plan/PlanStatusType";
import { initPlanAction }                from "../../../infrastructure/redux/plan/plan";
import DeleteButton                      from "../button/DeleteButton";
import EditButton                        from "../button/EditButton";
import ListTotalCount                    from "../common/layout/ListTotalCount";

type Props = {
  plans: Plans;
  count: number;
  deletePlan: (planId: PlanId) => void;
  updatePlanStatus: (planId: PlanId, statusType: PlanStatusType) => void;
}

const PlanListTable: FC<Props> = ({plans, count, deletePlan, updatePlanStatus}) => {
  const dispatch = useDispatch();

  if (plans.isEmpty()) {
    return (
      <>
        <Segment
          placeholder
        >
          <Header textAlign="center">
            プランがまだ作成されていません。
          </Header>
        </Segment>
      </>
    );
  }

  return (
    <>
      <ListTotalCount>{ count }件</ListTotalCount>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>プラン名</Table.HeaderCell>
            <Table.HeaderCell>設定金額</Table.HeaderCell>
            <Table.HeaderCell>予約受付</Table.HeaderCell>
            <Table.HeaderCell>操作</Table.HeaderCell>
            <Table.HeaderCell>作成日</Table.HeaderCell>
            <Table.HeaderCell>更新日</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            plans.list.map(plan => (
              <Table.Row key={ plan.id.toNumber() }>
                <Table.Cell>{ plan.name.toString() }</Table.Cell>
                <Table.Cell>{ plan.amount.toString() }</Table.Cell>
                <Table.Cell>
                  <Radio
                    toggle
                    label={ plan.statusType === PlanStatusType.PUBLISH ? "予約受付中" : "予約停止中" }
                    checked={ plan.statusType === PlanStatusType.PUBLISH }
                    onClick={ () => {
                      switch (plan.statusType) {
                        default:
                        case PlanStatusType.PRIVATE:
                          updatePlanStatus(plan.id, PlanStatusType.PUBLISH);
                          break;
                        case PlanStatusType.PUBLISH:
                          updatePlanStatus(plan.id, PlanStatusType.PRIVATE);
                      }
                    } }
                  />
                </Table.Cell>
                <Table.Cell>
                  <EditButton
                    onClick={ () => {
                      dispatch(initPlanAction(plan));
                      dispatch(push("/plan/edit"));
                    } }
                    label="編集する"
                  />
                  <DeleteButton
                    onClick={ () => deletePlan(plan.id) }
                    label="削除する"
                    modal={ {
                      title: `${ plan.name.toString() }を削除します。`,
                      description: "このプランですでに予約されたものは削除されないのでご注意ください。"
                    } }
                  />
                </Table.Cell>
                <Table.Cell>{ plan.trail.createdAt.toString() }</Table.Cell>
                <Table.Cell>{ plan.trail.updatedAt.toString() }</Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>
    </>
  );
};

export default PlanListTable;
